<p class="info info--ok" translate>auth.resetPassword.success</p>
<p class="recover-link" translate>auth.resetPassword.message <a [routerLink]="['/login']" translate>auth.resetPassword.link</a></p>



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/ubaristi-app-test/workspace/src/app/auth/reset-password/reset-password-done/reset-password-done.component.html